import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Table,
  Modal,
  Image,
  Card,
} from "react-bootstrap";

import { jsPDF } from "jspdf";

import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import Switch from "react-switch";
var dateFormat = require("dateformat");

class NormalOrdersView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        qntty: null,
      },
      itempage: 0,
      itemsperPage: 5,
      qty: 0,
      avlble: null,

      shwNormalconfirmModal: false,
      shwNormalrejectModal: false,
      showpaymntconfirmModalnormal: false,
      searchitems: "",
      searchShow: false,
      shwGetOrderConfirmModal: false,
    };
  }

  newitemOrderChange = (ev) => {
    let name = ev.target.name;
    let val = ev.target.value;
    if (name === "srchitem") {
      this.setState(
        {
          ...this.state,
          searchShow: true,
          searchitems: val,
        },
        () => {
          this.props.searchChemistitems({
            searchKey: this.state.searchitems,

            data: this.props.NormalordersToShow,
          });
        },
      );
    }
  };

  itemsPageClick = (ev) => {
    const selecteditemPage = ev.selected;
    this.props.itempageSelected({
      item: this.props.NormalordersToShow,
      page: selecteditemPage + 1,
    });
    this.setState({ itempage: selecteditemPage });
  };

  showconfirmModal = () => {
    this.setState({
      ...this.state,
      shwNormalconfirmModal: true,
    });
  };

  closeconfirmModal = () => {
    this.setState({
      ...this.state,
      shwNormalconfirmModal: false,
    });
  };

  showrejectModal = () => {
    this.setState({
      ...this.state,
      shwNormalrejectModal: true,
    });
  };

  closerejectModal = () => {
    this.setState({
      ...this.state,
      shwNormalrejectModal: false,
    });
  };

  createPdf = () => {
    let value = this.props.NormalordersToShow;
    this.props.pdfFullData(value);
  };

  _handleRadio = (event, index) => {
    if (!this.state.searchShow) {
      this.props.normalOrderDtls[index].avlble = event.target.value;
      this.props.normalOrderDtls[index].avlble =
        event.currentTarget.value === "true" ? true : false;
      this.setState({ avlble: event.avlble });
    } else {
      this.props.normalOrderSearchList[index].avlble = event.target.value;
      this.props.normalOrderSearchList[index].avlble =
        event.currentTarget.value === "true" ? true : false;
      this.setState({ avlble: event.avlble });
    }
  };

  add = (index, item) => {
    this.setState({ qty: item.avlblQntty });
    this.props.normalOrderDtls[index].avlblQntty += 1;
  };

  decrement = (index, item) => {
    this.setState({ qty: item.avlblQntty });

    if (this.props.normalOrderDtls[index].avlblQntty - 1 < 1) {
    } else {
      this.props.normalOrderDtls[index].avlblQntty -= 1;
    }
  };

  handleChange = (e, index, maxQty) => {
    let value = e.target.value;

    if (value === "") {
      value = "";
    } else {
      value = Number(value);
      if (isNaN(value) || value > maxQty) return;
    }

    if (!this.state.searchShow) {
      this.props.normalOrderDtls[index].avlblQntty = value;
    } else {
      this.props.normalOrderSearchList[index].avlblQntty = value;
    }

    this.setState({});
  };

  Submit = () => {
    const data =
      this.props.NormalordersToShow && this.props.NormalordersToShow.item
        ? this.props.NormalordersToShow.item
        : null;
    const createdByRoleKey =
      data && data.createdBy
        ? (data.createdBy.role || "").toLowerCase()
        : "";
    const shouldShowConfirmButton =
      createdByRoleKey === "employee" || createdByRoleKey === "distributor";
    const submitStatus = shouldShowConfirmButton ? "accepted" : "confirm";

    if (!this.state.searchShow) {
      let value = this.props.normalOrderDtls;

      let edit = false;
      {
        value.forEach((item) => {
          if (item.avlble === true) {
            edit = edit || true;
          } else {
            edit = edit || false;
          }
        });
      }

      if (edit === true) {
        this.setState({ value: this.props.normalOrderDtls.id });

        this.props.NormalOrderEdit({ items: value, status: submitStatus });
        this.props.close();
        this.setState({
          ...this.state,
          shwNormalconfirmModal: false,
        });
      } else {
        toast.error(
          "Sorry, you cannot accept this orde since no items are available now",
          {
            autoClose: 3000,
          },
        );

        this.setState({
          shwNormalconfirmModal: false,
        });
      }
    } else {
      this.setState({ value: this.props.normalOrderSearchList.id });
      let value = this.props.normalOrderSearchList;
      this.props.NormalOrderEdit({ items: value, status: submitStatus });
      this.props.close();
      this.setState({
        ...this.state,
        shwNormalconfirmModal: false,
      });
    }
  };

  reject = () => {
    let value = this.props.NormalordersToShow;
    this.props.NormalOrderReject(value);
    this.props.close();
    this.props.resetnewPage();

    this.setState({
      ...this.state,
      shwNormalrejectModal: false,
    });
  };

  normalchangetoPaid = (item) => {
    this.setState({
      showpaymntconfirmModalnormal: true,
      paymentStatusnormal: item,
    });
  };

  closepaymntconfirmModalnormal = () => {
    this.setState({
      showpaymntconfirmModalnormal: false,
    });
  };

  statusisPaid = () => {
    let value = this.state.paymentStatusnormal;
    this.props.changePaymentstatusnormal(value);
    this.props.close();
    this.props.resetnewPage();
    this.closepaymntconfirmModalnormal();
  };
  showGetOrderConfirmModal = () => {
    this.setState({
      shwGetOrderConfirmModal: true,
    });
  };

  closeGetOrderConfirmModal = () => {
    this.setState({
      shwGetOrderConfirmModal: false,
    });
  };

  handleGetOrder = () => {
    const data =
      this.props.NormalordersToShow && this.props.NormalordersToShow.item
        ? this.props.NormalordersToShow.item
        : null;
    this.props.NormalordersDelivered({ item: data });
    this.props.close();
    this.closeGetOrderConfirmModal();
  };

  render() {
    const data =
      this.props.NormalordersToShow && this.props.NormalordersToShow.item
        ? this.props.NormalordersToShow && this.props.NormalordersToShow.item
        : null;
    const createdByRoleKey =
      data && data.createdBy
        ? (data.createdBy.role || "").toLowerCase()
        : "";
    const shouldShowConfirmButton =
      createdByRoleKey === "employee" || createdByRoleKey === "distributor";
    const acceptActionLabel = shouldShowConfirmButton ? "Confirm" : "Accept";

    const items = this.props.normalOrderDtls
      ? this.props.normalOrderDtls
      : null;
    function capitalizeWord(word) {
      if (!word) return "";
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    const {
      avlble,
      shwNormalrejectModal,
      shwNormalconfirmModal,
      itempage,
      itemsperPage,
    } = this.state;

    const { itemsPageClick } = this;

    const count =
      this.props.normalOrderDtlsCount && this.props.normalOrderDtlsCount;
    let p1 = itempage + 1;
    let itemPageCount = Math.ceil(count / itemsperPage);

    const SearchCount =
      this.props.normalOrderSearchCount && this.props.normalOrderSearchCount;

    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            size="lg"
            backdrop="static"
            className="Modalmodelboxdesigns"
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white",
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Normal Order Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body id="check">
              <Row>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <div className="chemistdetails">
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Name : </span>{" "}
                      {data !== null && data.orderFrom
                        ? data.orderFrom.name + " " + data.orderFrom.lName
                        : null}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Mobile : </span>{" "}
                      {data !== null &&
                        data.orderFrom !== null &&
                        data.orderFrom
                        ? data.orderFrom.mobileNo
                        : null}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Email : </span>
                      {data !== null &&
                        data.chmstDtls !== null &&
                        data.chmstDtls
                        ? data.chmstDtls.email
                        : "Nill"}
                    </p>
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Address : </span>{" "}
                      {data !== null && data.addr},{" "}
                      {data !== null && data.pincode}
                    </p>
                  </div>
                </Col>

                <Col lg={6} md={6} sm={12} xs={12}>
                  <div className="chemistDtls">
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Order No : </span>{" "}
                      {data !== null && data.orderNo}
                    </p>
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Pharmacy : </span>{" "}
                      {data !== null && data.orderFromName}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> City : </span>{" "}
                      {data !== null && data.city}
                    </p>
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">
                        {" "}
                        Created Date :{" "}
                      </span>
                      {data !== null && data.createdAt
                        ? dateFormat(data.createdAt, "dd-mmm-yyyy, h:MM TT")
                        : null}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Created By : </span>{" "}
                      {data !== null && data.createdBy ? `${capitalizeWord(data.createdBy.fullName)} (${data.createdBy.designation || capitalizeWord(data.createdBy.role)})` : "Nill"}
                    </p>

                  </div>
                </Col>
              </Row>

              {data !== null &&
                (data.status === "shipmentReady" ||
                  data.status === "delivered") &&
                data.invDtls !== null &&
                data.invDtls.status === "open" && (
                  <Row className="viewRow">
                    <br />
                    <br />
                    <br />
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <p class="modelStatus">
                        Payment Status :{" "}
                        <span style={{ textTransform: "uppercase" }}>
                          {data !== null && data.invDtls && data.invDtls.status}
                        </span>
                        <br />
                        <span>
                          Amount : INR{" "}
                          {data !== null && data.invDtls && data.invDtls.amount}
                        </span>
                        <br />
                        <span>
                          Remarks:{" "}
                          {data !== null && data.prcpNotes
                            ? data.prcpNotes
                            : "No additional notes"}
                        </span>
                      </p>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6} className="chemistDtls">
                      <Button
                        className="queryBtn"
                        onClick={() => this.normalchangetoPaid({ item: data })}
                      >
                        Order Paid?
                      </Button>
                    </Col>
                  </Row>
                )}

              {data !== null &&
                (data.status === "shipmentReady" ||
                  data.status === "delivered") &&
                data.invDtls !== null &&
                data.invDtls.status === "paid" && (
                  <Row>
                    <br />
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <p
                        style={{
                          marginLeft: "20px",
                          color: "rgb(204, 32, 38)",
                          fontWeight: "bold",
                        }}
                      >
                        Payment Status :{" "}
                        <span style={{ textTransform: "uppercase" }}>
                          {data !== null && data.invDtls && data.invDtls.status}
                        </span>
                        <br />
                        <span>
                          Amount : INR{" "}
                          {data !== null && data.invDtls && data.invDtls.amount}
                        </span>
                        <br />
                        <span>
                          Remarks:{" "}
                          {data !== null && data.prcpNotes
                            ? data.prcpNotes
                            : "No additional notes"}
                        </span>
                      </p>
                    </Col>
                  </Row>
                )}

              {data !== null &&
                data.status !== "shipmentReady" &&
                data.status !== "delivered" && (
                  <Row>
                    <br />
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <p
                        style={{
                          marginLeft: "20px",
                          color: "rgb(204, 32, 38)",
                          fontWeight: "bold",
                        }}
                      >
                        Remarks:{" "}
                        {data !== null && data.prcpNotes
                          ? data.prcpNotes
                          : "No additional notes"}
                      </p>
                    </Col>
                  </Row>
                )}

              <div className="coomonlinebody">
                <hr />
              </div>

              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h3 className="itemdetailshd">Item Details</h3>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                  {data !== null && data.status === "created" ? (
                    <div className="commonInputdiv">
                      <div className="commonInput">
                        <i className="fa fa-search fa-lg cmnSearchIcon" />
                        <input
                          type="text"
                          name="srchitem"
                          autoComplete="off"
                          placeholder="Item Name"
                          value={this.state.searchitems}
                          onChange={this.newitemOrderChange}
                        />
                      </div>
                    </div>
                  ) : null}
                </Col>

                <Col xs={12} sm={12} md={2} lg={2} />
                <Col xs={12} sm={12} md={3} lg={3}>
                  <div style={{ paddingLeft: "20px" }}>
                    <span className="cmnPageCount">
                      {count === undefined && SearchCount === undefined ? (
                        0
                      ) : (
                        <span>
                          {!this.state.searchShow && count}
                          {this.state.searchShow && SearchCount}
                        </span>
                      )}
                    </span>
                    <span className="cmnResutText">Items</span>
                  </div>
                </Col>
              </Row>

              {data !== null && data.status === "shipmentReady" ? (
                <div>
                  <p className="messagetext">
                    Waiting for item receipt from chemist{" "}
                  </p>
                </div>
              ) : null}

              {data !== null && data.status === "delivered" ? (
                <div>
                  <p className="messagetext">Delivery Completed</p>
                </div>
              ) : null}

              {data !== null &&
                data.hasCreated &&
                data.status === "accepted" ? (
                <div>
                  <p className="messagetext">Dispatched items</p>
                </div>
              ) : null}

              <div>
                {data !== null && data.hasCreated ? null : data !== null &&
                  data.status === "confirm" ? (
                  <p className="messagetext">
                    Waiting for chemist confirmation
                  </p>
                ) : data !== null && data.status === "created" ? null : data !==
                  null && data.status === "cancelled" ? null : data !==
                    null && data.status === "rejected" ? null : (
                  <div>
                    <p className="messagetext">Upload Invoice</p>
                  </div>
                )}
              </div>

              <Card.Body>
                <div className="viewnormaltablecommon">
                  {!this.state.searchShow && (
                    <Table className="dashTable">
                      <thead className="tablecommonclr">
                        <tr>
                          <th>#</th>
                          <th>Item Code</th>
                          <th>Item Name</th>
                          <th>Available Quantity</th>
                          <th>Order Quantity</th>
                          {data && data.status === "rejected" ? (
                            ""
                          ) : (
                            <th>Availability</th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="tablecommonclrtbody tableBody">
                        {this.props.normalOrderDtls &&
                          this.props.normalOrderDtls.map(
                            (item, i) => (
                              (this.state.qty = item.avlblQntty),
                              (
                                <tr key={i}>
                                  <th scope="row">{5 * (p1 - 1) + i + 1}</th>
                                  <td className="cmn_Cap">
                                    {item !== null &&
                                      item.itemCode !== null &&
                                      item.itemCode !== undefined &&
                                      item.itemCode.drugCode}
                                  </td>
                                  <td className="cmn_Cap">
                                    {item !== null && item.itemName}
                                  </td>
                                  <td className="cmn_Cap">
                                    {data !== null &&
                                      data.status === "created" ? (
                                      <div className="radiobtnclass">
                                        <input
                                          type="number"
                                          className="textBox form-control"
                                          name="avlblQntty"
                                          min={0}
                                          max={item.qntty}
                                          value={item.avlblQntty ?? ""}
                                          onChange={(e) =>
                                            this.handleChange(e, i, item.qntty)
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <div>{item?.avlblQntty}</div>
                                    )}
                                  </td>

                                  <td className="cmn_Cap">
                                    {item !== null && item.qntty}
                                  </td>

                                  {data !== null &&
                                    data.status === "created" ? (
                                    <td className="cmn_Cap">
                                      <div className="radiobtnclass">
                                        <label>
                                          <input
                                            type="radio"
                                            value="true"
                                            defaultChecked
                                            checked={item.avlble === true}
                                            onChange={(e) =>
                                              this._handleRadio(e, i)
                                            }
                                          />
                                          Yes
                                        </label>

                                        <label>
                                          <input
                                            type="radio"
                                            value="false"
                                            checked={item.avlble === false}
                                            onChange={(e) =>
                                              this._handleRadio(e, i)
                                            }
                                          />
                                          No
                                        </label>
                                      </div>
                                    </td>
                                  ) : data !== null &&
                                    data.status === "rejected" ? (
                                    ""
                                  ) : (
                                    <td className="cmn_Cap">
                                      <div>
                                        {item !== null && item.avlble === true
                                          ? "Available"
                                          : "Not Available"}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              )
                            ),
                          )}
                      </tbody>
                    </Table>
                  )}

                  {this.state.searchShow && (
                    <Table className="dashTable">
                      <thead className="tablecommonclr">
                        <tr>
                          <th>#</th>
                          <th>Item Code</th>
                          <th>Item Name</th>
                          <th style={{ width: "20%" }}>Quantity</th>

                          {data && data.status === "rejected" ? (
                            ""
                          ) : (
                            <th>Availability</th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="tablecommonclrtbody tableBody">
                        {this.props.normalOrderSearchList &&
                          this.props.normalOrderSearchList.map(
                            (item, i) => (
                              (this.state.qty = item.avlblQntty),
                              (
                                <tr key={i}>
                                  <th scope="row">{5 * (p1 - 1) + i + 1}</th>
                                  <td className="cmn_Cap">
                                    {item !== null &&
                                      item.itemCode !== null &&
                                      item.itemCode !== undefined &&
                                      item.itemCode.drugCode}
                                  </td>
                                  <td className="cmn_Cap">
                                    {item !== null && item.itemName}
                                  </td>
                                  <td className="cmn_Cap">
                                    {data !== null &&
                                      data.status === "created" ? (
                                      <div className="radiobtnclass">
                                        <input
                                          type="text"
                                          className="textBox form-control"
                                          name="avlblQntty"
                                          autoComplete="off"
                                          value={this.state.qty}
                                          onChange={(e) =>
                                            this.handleChange(e, i)
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <div>
                                        {item !== null && item.avlblQntty}
                                      </div>
                                    )}
                                  </td>

                                  {data !== null &&
                                    data.status === "created" ? (
                                    <td className="cmn_Cap">
                                      <div className="radiobtnclass">
                                        <label>
                                          <input
                                            type="radio"
                                            value="true"
                                            defaultChecked
                                            checked={item.avlble === true}
                                            onChange={(e) =>
                                              this._handleRadio(e, i)
                                            }
                                          />
                                          Yes
                                        </label>

                                        <label>
                                          <input
                                            type="radio"
                                            value="false"
                                            checked={item.avlble === false}
                                            onChange={(e) =>
                                              this._handleRadio(e, i)
                                            }
                                          />
                                          No
                                        </label>
                                      </div>
                                    </td>
                                  ) : data !== null &&
                                    data.status === "rejected" ? (
                                    ""
                                  ) : (
                                    <td className="cmn_Cap">
                                      <div>
                                        {item !== null && item.avlble === true
                                          ? "Available"
                                          : "Not Available"}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              )
                            ),
                          )}
                      </tbody>
                    </Table>
                  )}

                  {!this.state.searchShow &&
                    (this.props.normalOrderDtls === undefined ||
                      (this.props.normalOrderDtls &&
                        this.props.normalOrderDtls.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">No Items Found</div>
                      </div>
                    )}
                  {this.state.searchShow &&
                    (this.props.normalOrderSearchList === undefined ||
                      (this.props.normalOrderSearchList &&
                        this.props.normalOrderSearchList.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">No Items Found</div>
                      </div>
                    )}
                </div>
              </Card.Body>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
              {data !== null && data.status === "created" ? (
                <div>
                  <Button className="queryBtn" onClick={this.createPdf}>
                    Download as PDF
                  </Button>
                  <Button className="queryBtn" onClick={this.showrejectModal}>
                    Reject
                  </Button>
                  <Button
                    className="queryBtnaccept"
                    onClick={this.showconfirmModal}
                  >
                    {acceptActionLabel}
                  </Button>
                </div>
              ) : null}
              {data !== null &&
                data.status === "shipmentReady" &&
                data.createdBy &&
                (data.createdBy.role === "employee" ||
                  data.createdBy.role === "distributor") && (
                  <div>
                    <Button
                      className="queryBtnaccept"
                      onClick={this.showGetOrderConfirmModal}
                    >
                      Get Order
                    </Button>
                  </div>
                )}
            </Modal.Footer>
          </Modal>
        </div>
        <Modal
          show={shwNormalrejectModal}
          onHide={this.closerejectModal}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b> Reject Order?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={this.closerejectModal}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.reject}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        <Modal
          show={shwNormalconfirmModal}
          onHide={this.closeconfirmModal}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>{acceptActionLabel} Order?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={this.closeconfirmModal}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.Submit}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showpaymntconfirmModalnormal}
          onHide={this.closepaymntconfirmModalnormal}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Order Paid?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={this.closepaymntconfirmModalnormal}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.statusisPaid}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.shwGetOrderConfirmModal}
          onHide={this.closeGetOrderConfirmModal}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Has the chemist received the order?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={this.closeGetOrderConfirmModal}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.handleGetOrder}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default NormalOrdersView;
